export default
`  
   
 
 
 
    Hugo Music Player
    File:
    alex_get_a_new_job.hugomusic
    [22 bytes]
 
                [╔, , , , , , , ,╔,╔,╔,╔,╔,╔,╔,╔][═,═, , , , , , , ,═,═,═,═,═,═,═][╗,╗,╗, , , , , , , ,╗,╗,╗,╗,╗,╗]
                [║,║,║,║,║,║,║,║, , , , , , , ,║][ , , , , , , , , , , , , , , , ][║,║,║,║, , , , , , , ,║,║,║,║,║]
                [╚,╚,╚,╚,╚,╚,╚, , , , , , , ,╚,╚][═,═,═,═,═,═, , , , , , , ,═,═,═][╝,╝,╝,╝,╝, , , , , , , ,╝,╝,╝,╝]
  
  
  
 `